import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { LANGUAGES_SHORT } from '../constants';

const useResonanceLanguageOptions = () => {
  const { t } = useTranslation('header');

  return useMemo(
    () => [
      {
        label: t('english'),
        value: LANGUAGES_SHORT.ENGLISH,
        icon: '🇬🇧',
      },
      {
        label: t('german'),
        value: LANGUAGES_SHORT.GERMAN,
        icon: '🇩🇪',
      },
    ],
    [t],
  );
};

export default useResonanceLanguageOptions;
